(() => {
  const main = document.getElementById('MainContent');
  if (!main || !Element.prototype.animate || document.documentElement.classList.contains('shopify-design-mode')) return;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set();
  const listeners = new AbortController();

  function finish() {
    for (const animation of active) animation.cancel();
    active.clear();
    listeners.abort();
  }

  function enter() {
    if (preference.matches || document.visibilityState !== 'visible') return;
    // One composition on arrival. Scrolling, filters, galleries and forms remain still.
    const selector = 'product-card, .hb-discover__track > li, .hb-grid > a, .hb-hero-media, .product-information__media';
    const candidates = [...main.querySelectorAll(selector)];
    const visible = candidates.filter(element => {
      if (element.closest('dialog, [hidden]') || element.parentElement?.closest('product-card')) return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
    }).slice(0, 12);

    visible.forEach((element, index) => {
      // Opaque throughout: never wash out imagery or expose a white canvas.
      const hero = element.matches('.hb-hero-media, .product-information__media');
      const animation = element.animate([
        { transform: hero ? 'translateY(8px) scale(.995)' : 'translateY(16px) scale(.978)' },
        { transform: 'translateY(0) scale(1)' }
      ], {
        duration: 640,
        delay: Math.min(index * 45, 180),
        easing: 'cubic-bezier(.22,1,.36,1)',
        fill: 'backwards'
      });
      active.add(animation);
      animation.finished.catch(() => {}).finally(() => {
        active.delete(animation);
        if (!active.size) listeners.abort();
      });
    });
    if (!active.size) return;
    // Visitor interaction takes priority over the brief entrance.
    for (const event of ['pointerdown', 'keydown', 'wheel', 'touchstart']) {
      window.addEventListener(event, finish, { passive: true, once: true, signal: listeners.signal });
    }
    window.addEventListener('pagehide', finish, { once: true, signal: listeners.signal });
    preference.addEventListener('change', finish, { once: true, signal: listeners.signal });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enter, { once: true });
  else enter();
})();
